import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { Interest, InterestModel, EditInterest } from "../../models/inModels/Interest";
import { AuthenticationService } from '../authentication/authentication.service';


@Injectable()
export class InterestsService {
  private routeInterest = '/api/interests';

  constructor(
    private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
  ) { }

  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeInterest }/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
  }
	
  get(id: number): Promise<Interest> {
	return this.http.get(`${this.auth.apiUrl}${this.routeInterest}/get/${id}`, { headers: this.auth.header })
		.toPromise()
		.then(response => response as Interest)
		.catch(error => this.logging.handleError(error));
}


  create(user: InterestModel): Promise<Interest> {
		return this.http.post(`${this.auth.apiUrl}${this.routeInterest}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Interest)
			.catch(error => this.logging.handleError(error));
  }

  update(user: EditInterest): Promise<Interest> {
		return this.http.post(`${this.auth.apiUrl}${this.routeInterest}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Interest)
			.catch(error => this.logging.handleError(error));
  }
  
  delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeInterest}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/business/interests.service.ts